<template>
  <div class="shop-half-ring-wrap" v-if="type == 1">
    <div ref="chartRef" class="shop-half-ring-chart"></div>
    <div class="title-box">
      <div class="ratoe">{{ value }}%</div>
      <div class="title">
        <span>{{ title }}</span>
        <el-tooltip
          v-if="item.tips"
          placement="right"
          width="200"
          effect="light"
          trigger="hover"
          :content="item.tips"
        >
          <i class="new-icon-box" style="margin-left: 4px"></i>
        </el-tooltip>
      </div>
    </div>
  </div>
  <div class="ring2" v-else-if="type == 2">
    <div
      ref="chartRef"
      :style="{ width: chartWidth + 'px', height: chartHeight + 'px' }"
    ></div>
    <div class="label-box" v-if="icon">
      <img style="width: 26px; height: 26px" :src="icon" alt="" />
    </div>
    <div class="label-box" v-else>
      <div class="value">{{ value }}%</div>
      <div class="label">{{ item.label }}</div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";

export default {
  name: "ShopHalfRing",
  props: {
    title: { type: String, default: "" },
    value: { type: Number, default: 0 },
    color: { type: String, default: "#3159ff" },
    trackColor: { type: String, default: "#eef1f5" },
    valueFontSize: { type: Number, default: 26 },
    tooltipText: { type: String, default: "" },
    item: { type: Object, default: () => ({}) },
    type: { type: [String, Number], default: 1 },
    chartWidth: { type: Number, default: 200 },
    chartHeight: { type: Number, default: 200 },
    icon: { type: String, default: "" },
  },
  data() {
    return { chartInstance: null };
  },
  watch: {
    value() {
      this.updateChart();
    },
    color() {
      this.updateChart();
    },
    title() {
      this.updateChart();
    },
    tooltipText() {
      this.updateChart();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
      window.addEventListener("resize", this.handleResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
  },
  methods: {
    handleResize() {
      this.chartInstance && this.chartInstance.resize();
    },
    initChart() {
      this.chartInstance = echarts.init(this.$refs.chartRef);
      this.chartInstance.setOption(this.buildOption());
    },
    updateChart() {
      if (!this.chartInstance) return;
      this.chartInstance.setOption(this.buildOption(), true);
    },
    buildOption() {
      if (this.type == 2) {
        return this.buildOption2();
      }
      // 约束 value 到 [0, 100]
      const val = Math.max(0, Math.min(100, Number(this.value) || 0));
      // ===== ECharts 4.x 兼容方案 =====
      // v4 不支持 endAngle，用 startAngle + 数据分段实现半圆
      // 完整 360° 拆成 上半圆 180°（可见）+ 下半圆 180°（透明缺口）
      const HALF = 180;
      // 进度弧在上半圆中占据的角度
      const progressAngle = (val / 100) * HALF;

      return {
        tooltip: {
          show: false,
        },
        series: [
          // 底层：完整灰色上半圆轨道 + 下半圆透明缺口
          {
            type: "pie",
            hoverAnimation: false,
            radius: ["85%", "100%"],
            center: ["50%", "50%"],
            startAngle: 180,
            silent: true,
            label: { show: false },
            labelLine: { show: false },
            tooltip: { show: false },
            data: [
              {
                value: HALF,
                itemStyle: { color: this.trackColor },
                emphasis: { itemStyle: { color: this.trackColor } },
              }, // 上半圆 180° 灰色
              {
                value: HALF,
                itemStyle: { color: "transparent" },
                emphasis: { itemStyle: { color: "transparent" } },
              }, // 下半圆 180° 透明
            ],
          },
          // 上层：彩色进度弧 + 剩余灰色轨道 + 下半圆透明
          {
            type: "pie",
            hoverAnimation: false,
            radius: ["85%", "100%"],
            center: ["50%", "50%"],
            startAngle: 180,
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            labelLine: { show: false },
            data: [
              {
                name: this.title || "progress",
                value: progressAngle,
                itemStyle: { color: this.color },
              },
              {
                name: "__remain__",
                value: HALF - progressAngle,
                itemStyle: { color: this.trackColor },
                emphasis: { itemStyle: { color: this.trackColor } },
                tooltip: { show: false },
              },
              {
                name: "__gap__",
                value: HALF,
                itemStyle: { color: this.trackColor },
                emphasis: { itemStyle: { color: this.trackColor } },
                tooltip: { show: false },
              },
            ],
          },
        ],
      };
    },
    buildOption2() {
      let option = {
        tooltip: {
          show: false,
        },
        legend: {
          show: false,
        },
        series: [
          {
            type: "pie",
            hoverAnimation: false,
            radius: ["80%", "100%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            labelLine: { show: false },
            data: [
              {
                value: Number(this.value),
                name: "Search Engine",
                itemStyle: { color: this.color },
                emphasis: { itemStyle: { color: this.color } },
              },
              {
                value: 100 - Number(this.value),
                name: "Search 2Engine",
                itemStyle: { color: this.trackColor },
                emphasis: { itemStyle: { color: this.trackColor } },
              },
            ],
          },
        ],
      };
      return option;
    },
  },
};
</script>

<style lang="scss" scoped>
.shop-half-ring-wrap {
  width: 200px;
  height: 200px;
  position: relative;
  .title-box {
    position: absolute;
    left: 50%;
    top: 44px;
    transform: translateX(-50%);
    .ratoe {
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      text-align: center;
    }
    .title {
      white-space: nowrap;
      margin-top: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #333333;
    }
  }
}
.shop-half-ring-chart {
  width: 200px;
  height: 200px;
}
.ring2 {
  position: relative;
  .label-box {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .value {
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      text-align: center;
    }
    .label {
      margin-top: 8px;
      font-size: 14px;
      color: #333333;
    }
  }
}
</style>
